import { OrganizationUnitType as ApiOrganizationUnitType } from 'src/api/generated/touring/types';
import { OrganizationUnitType } from './types';

export const mapOrganizationUnitType = (
  apiOrgUnit: ApiOrganizationUnitType
): OrganizationUnitType => {
  return {
    id: apiOrgUnit.id,
    name: apiOrgUnit.name,
  };
};
